export const getTheMonthName = (date: Date) => {
    const monthNames = ["January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    let result = '';
    if (date) {
        result = monthNames[date.getMonth()];
    }
    return result;
}